module.exports = __webpack_public_path__ + "img/TL.9ec18820.svg";